import React from 'react'
import Modal3 from '../Modal3'
import t from '../../i18n/I18n';
import { useState,useRef } from 'react';
import { Checkbox } from '../../common/form';
import { useEffect } from 'react';
import { toast } from '../../store/StoreUtil';
import './LogManagementModal.css';
import { ThemeSetup } from '../../themes/ThemeSetup';
import { logsCategoryData } from '../../util/Constants';
const hubLogsGetUrl = "http://localhost:8282/admin/logs/fetchLogs";
const cpHotFolderGetUrl = "http://localhost:7770/webmin/logs/fetch";
const postUrlHub = "http://localhost:8282/admin/logs/downloadLogs";
const postUrlCpHot = "http://localhost:7770/webmin/logs/download";


export default function LogManagementModal({ onClose }) {
  const [isAllChecked, setAllChecked] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [downloadPath, setDownloadPath] = useState("");
  const [selectedCount, setSelectedCount] = useState(0);
  const [downloadLogsUrl, setDownloadLogsUrl] = useState("");
  const [logsDataCategory, setLogsDataCategory] = useState([]);

  const selectedFilesToDownload = {
    fileCount: 0,
    fileList: []
  }

  function closeModal() {
    onClose();
  }

  async function downloadLogs(e) {
    for (let i = 0; i < apiData.length; i++) {
      if (apiData[i].isChecked) {
        selectedFilesToDownload.fileCount++;
        let value = downloadPath + apiData[i].label;
        selectedFilesToDownload.fileList.push(value);
      }
    }
    if (selectedFilesToDownload.fileCount > 0) {
      e.preventDefault();
      const postApiResponse = await fetch(downloadLogsUrl, {
        method: 'POST',
        body: JSON.stringify(selectedFilesToDownload),
        headers: {
          'Content-type': 'application/jsonResponseGetApi; charset=UTF-8',
        },
      })
      const jsonResponsePostApi = await postApiResponse.json();
      if (jsonResponsePostApi.message === "Success") {
        toast(t('DOWNLOAD_FILES'));
        closeModal();
      }
    }
    else {
      toast(t('SELECT_FILE'));
    }
  }

  useEffect(() => {
    fetchDataLogsCategory(cpHotFolderGetUrl);
    fetchapiData(hubLogsGetUrl);
    setDownloadLogsUrl(postUrlHub);
    document.getElementsByClassName("primary")[0].style.width = "137px";
  }, [])

  useEffect(() => {
    const allAreFalse = apiData.every((element) => {
      return element.isChecked === false;
    })
    if (allAreFalse) {
      document.getElementsByClassName("primary")[0].style.backgroundColor = "var(--bg-color-modal3-before-select)"
      document.getElementsByClassName("primary")[0].style.color = "var(--button-color-modal3-before-select)"
    }
  }, [apiData])

  function getButton() {
    if (apiData.length === 0) {
      return "Download";
    }
    else {
      let count = 0;
      for (let i = 0; i < apiData.length; i++) {
        if (apiData[i].isChecked) {
          count++;
        }
      }
      return `Download(${count})`
    }
  }

  const modalProps = {
    name: 'Log Management',
    title: t('LOG_MANAGEMENT'),
    onClose,
    buttons: [
      { label: t('CANCEL_BUTTON'), type: 'CANCEL', onClick: onClose },
      { label: getButton(), type: 'PRIMARY', onClick: downloadLogs, style:isChecked || isAllChecked?{backgroundColor:"var(--bg-color-modal3-after-select)",color:"var(--button-color-modal3-after-select)"}:{backgroundColor:"var(--bg-color-modal3-before-select)",color:"var(--button-color-modal3-before-select)"} }
    ]
  }

  const formatapiData = (jsonResponseApiData, pathName) => {
    let lastIndexOfPath = pathName.lastIndexOf('\\');
    let pathPrefix = pathName.substring(0, lastIndexOfPath + 1);
    setDownloadPath(pathPrefix);
    let get_API_Data = [];
    for (let file of jsonResponseApiData) {
      const str = file.split(/[\\\/]/);
      get_API_Data.push({ label: str[str.length - 1], isChecked: false });
    }
    setApiData(get_API_Data);
  }

  async function fetchapiData(URL) {
    try {
      const getApiResponse = await fetch(URL);
      const jsonResponseGetApi = await getApiResponse.json();
      let pathName = jsonResponseGetApi.fileNames[0];
      formatapiData(jsonResponseGetApi.fileNames, pathName);
    }
    catch (error) {
      console.log(`${error}`)
    }
  }

  async function fetchDataOfOtherLogs(URL, index) {
    try {
      const response = await fetch(URL);
      const jsonResponse = await response.json();
      const pathName = jsonResponse.logDetails[index].fileNames[index];
      formatapiData(jsonResponse.logDetails[index].fileNames, pathName)
    }
    catch (error) {
      console.log(`${error}`)
    }
  }

  async function fetchDataLogsCategory(URL) {
    try {
      const response = await fetch(URL);
      const jsonResponse = await response.json();
      for (let value of jsonResponse.logDetails) {
        if (value.logName === "CLIENTPROXY")
          logsCategoryData["CLIENTPROXY"] = "Clientproxy Logs";
        else if (value.logName === "HOT-FOLDER")
          logsCategoryData["HOT-FOLDER"] = "Hot Folder";
        else
          logsCategoryData["OTHER-LOGS"] === "Other Logs";
      }
      setLogsDataCategory(logsCategoryData);
    }
    catch (error) {
      console.log(`${error}`);
    }
  }

  const onChangeLogsCategory = (e) => {
    document.getElementById("All_Files").style.backgroundColor = 'var(--list-item-bg-color)'
    setApiData([]);
    setAllChecked(false);
    setChecked(false)
    const { value } = e.target;
    var index;
    if (value === "Clientproxy Logs" || value === "Hot Folder")
      setDownloadLogsUrl(postUrlCpHot);
    else
      setDownloadLogsUrl(postUrlHub);
    switch (value) {
      case "Hub Logs":
        fetchapiData(hubLogsGetUrl);
        break;
      case "Clientproxy Logs":
        index = 0;
        fetchDataOfOtherLogs(cpHotFolderGetUrl, index);
        document.getElementsByClassName("primary")[0].style.width = "137px"
        break;
      case "Hot Folder":
        index = 1;
        fetchDataOfOtherLogs(cpHotFolderGetUrl, index);
        document.getElementsByClassName("primary")[0].style.width = "137px"
        break;
      case "Other Logs":
        setApiData([])
        document.getElementsByClassName("primary")[0].style.width = "117px"
        break;
    }
  }

  function selectAllFiles(e) {
    const { checked } = e.target; 
    setAllChecked(checked);
    let selectedLogs = apiData.map(user => { return { ...user, isChecked: checked } });
    setApiData(selectedLogs);
    if (checked) {
      setChecked(true);
      setSelectedCount(apiData.length)
      for (let i = 0; i < document.getElementsByClassName("list_items").length; i++) {
        document.getElementsByClassName("list_items")[i].style.backgroundColor = "var(--on-select-bg-color)"
      }
    }
    else {
      setChecked(false);
      setSelectedCount(0);
      for (let i = 0; i < document.getElementsByClassName("list_items").length; i++) {
        document.getElementsByClassName("list_items")[i].style.backgroundColor = "var(--list-item-bg-color)"
      }
    }
  }

  const onChangeLogFiles = (e, index) => {
    const { checked } = e.target;
      const updatedData = [...apiData];
      updatedData[index].isChecked = checked
      setApiData(updatedData);
      if (checked) {
        setSelectedCount(prevCount => prevCount+1);
        setAllChecked(true);
        setChecked(true);
        e.target.parentElement.parentElement.parentElement.parentElement.parentElement.style.backgroundColor = 'var(--on-select-bg-color)'
      }
      else {
        setChecked(false);    
        setSelectedCount(prevCount => {
          const currectCount = prevCount-1;
          if(currectCount === 0) setAllChecked(false);
          return currectCount;
        });
      }
    
  }
  
  return (
    <Modal3 {...modalProps} closeOnEsc={true} closeOnOutsideClick={true}>
      <div className="modal-subheader-category" >{t('Select Logs Category')}</div>
      <div >
      <select onChange={onChangeLogsCategory} >
          {Object.values(logsDataCategory).map((value, key) => (
            value === "" ? null : <option key={key} value={value}>{value} </option>
          ))}
        </select>
      </div>
      <div className="modal-subheader-files" >{t('Select Logs Files')}</div>
      <div className="sub-div" >
      <div id='All_Files' style={isAllChecked ? {backgroundColor: "var(--on-select-bg-color)"} : {}}>
          <span >
            {apiData.length > 0 ? <Checkbox  checked={isAllChecked} onChange={(e)=>selectAllFiles(e)} label={t('ALL_FILES')} checkboxStyle={{ backgroundImage:  selectedCount === 0 ? null : selectedCount === apiData.length ? ThemeSetup.getBackgroundURL('checkbox_white.svg') : 'var(--icon-hiphen-allFiles)',border:isAllChecked?null:"2px solid var(--primary-font-color)"}} labelStyle={{color:"var(--logs-category-font-modal3)"}}/> : null}
          </span>
        </div>
        {apiData.map((value, index) => (
          <div key={index} className="list_items" style={value?.isChecked ? {backgroundColor: "var(--on-select-bg-color)"} : {}}>
            <div className='logs-category-item'>
              <span>
                <Checkbox checked={value?.isChecked || false} onChange={(e) => onChangeLogFiles(e, index)} label={value.label} checkboxStyle={{border:value?.isChecked?null:"2px solid var(--primary-font-color)"}} labelStyle={{color:"var(--logs-category-font-modal3)"}}/>
              </span>
            </div>
          </div>
        ))
        }
      </div>
    </Modal3>
  )
}
